export default __webpack_public_path__ + "static/media/trigger.6f27be4b.png";